<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { cn } from '@/utils/RandomUtils.ts';

const props = defineProps<{
    class?: HTMLAttributes['class'];
}>();
</script>

<template>
    <span
        role="link"
        aria-disabled="true"
        aria-current="page"
        :class="cn('font-normal text-zinc-950 dark:text-zinc-50', props.class)"
    >
        <slot />
    </span>
</template>
